export default (number, isPrice = false) => {
  let val = number
    .toString()
    .replace(/[^0-9.]/g, "")
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");

  if (isPrice) {
    return `$${val}`;
  }

  if (val.includes(".")) {
    let splitNumber = val.split(".");
    if (splitNumber[1] && splitNumber[1].trim().length > 2) {
      splitNumber[1] = parseFloat(splitNumber[1]).toFixed();
      splitNumber[1].toString();
      val = splitNumber.join(".");
    }
  }
  return val;
};
  